import type { ChannelName } from "../../../../channels/types";
import type { SegmentJson } from "../../../types/segment-schema";

export const hasElements = (segment: SegmentJson | null | undefined): segment is SegmentJson =>
  segment !== null &&
  segment !== undefined &&
  (segment.type === "magic" || (segment.type === "segment" && segment.segments.length > 0));
export const plural = (n: number, singular: string, pluralForm = `${singular}s`): string =>
  n === 1 ? singular : pluralForm;

/** "1 person", "3 people" */
export const people = (n: number): string => `${n} ${plural(n, "person", "people")}`;

type Channel = NonNullable<ChannelName>;

/** Text for the "not currently receiving" modal: the address is opted out. Slack can't opt out, so it has none. */
export const suppressedDescription: Partial<Record<Channel, string>> = {
  work_email:
    "These people are not currently receiving Work Email Communications. They may have blocked emails from this platform, their email address may be incorrect, not set up for external emails, not fully set up when we first tried to contact them, or their inbox may be full. Please ask your HRIS or IT team to check these details.",
  teams:
    "These people are not currently receiving Teams Communications. They may have blocked messages from your Teams bot, or their email address may be incorrect. Please ask your HRIS or IT team to check these details.",
  whatsapp:
    "These people are not currently receiving WhatsApp Communications. They may have replied “STOP” to a previous WhatsApp message from you, their phone number may be incorrect, or they don’t have a WhatsApp account.",
  twilio:
    "These people are not currently receiving SMS Communications. They may have replied “STOP” to a previous SMS message from you, or their provider has blocked messages from this platform, or their phone number may be invalid.",
  personal_email:
    "These people are not currently receiving Personal Email Communications. They may have blocked messages from this platform, or their email address may be incorrect.",
};

/** Text for the "People without" modal: the person has no address on the platform. */
export const notEnabledDescription: Partial<Record<Channel, string>> = {
  work_email: "We can’t find a Work Email for these people.",
  teams: "We can’t find a Teams account for these people.",
  whatsapp:
    "We can’t find a phone number for these people, so they can’t be sent WhatsApp Communications.",
  twilio:
    "We can’t find a phone number for these people, so they can’t be sent SMS Communications.",
  personal_email:
    "We can’t find a Personal Email for these people, so they can’t be sent Personal Email Communications.",
  slack:
    "We can’t find a Slack account for these people. It could be that they don’t have a Slack account, or their email address may be incorrect.",
};
